import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { Button, Stack, Text } from "@mantine/core";
import { Rizvoice, RizvoiceContext } from "./stores/Rizvoice";
import { startAccountsActionCable } from "./helpers/actionCable";
import Paywall from "./rizvoiceComponents/paywall";
import Subscriptions from "./rizvoiceComponents/subscriptions";
import RizvoiceModals from "./rizvoiceComponents/rizvoiceModals";
import BasicHeader from "./cubbyComponents/dataDisplay/basicHeader";
import DocsHeader from "./docs/DocsHeader";

const RizvoiceContainer: React.FC = observer(() => {
  const rizvoice = useContext<Rizvoice>(RizvoiceContext);

  useEffect(() => {
    rizvoice.hydrateDataFromPage();
  }, []);

  return (
    <>
      {rizvoice.hasLoaded && (
        <Stack>
          <DocsHeader is_logged_in={true} />
          {rizvoice.shouldOfferSubscription && (
            <Subscriptions rizvoice={rizvoice} />
          )}

          {!rizvoice.shouldOfferSubscription &&
            rizvoice.mustMakeInvoicePaymentBeforeClaimingCubby && (
              <Paywall rizvoice={rizvoice} />
            )}
          {!rizvoice.shouldOfferSubscription &&
            !rizvoice.mustMakeInvoicePaymentBeforeClaimingCubby && (
              <Stack>
                {" "}
                <Text>Payment successful.</Text>
                <Button component="a" href="/nodes">
                  Click here to continue
                </Button>
              </Stack>
            )}
          <RizvoiceModals rizvoice={rizvoice} />
        </Stack>
      )}
    </>
  );
});

export default RizvoiceContainer;
